<template>
  <div v-if="bubble && bubble.text" :key="bubble.token" class="chat-bubble">
    <ChatRichText :text="bubble.text" compact />
  </div>
</template>

<script>
import ChatRichText from '@/components/ChatRichText.vue'

export default {
  name: 'ChatBubble',
  components: { ChatRichText },
  props: {
    bubble: {
      type: Object,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.chat-bubble {
  position: absolute;
  left: 50%;
  bottom: calc(100% + 6px);
  z-index: 6;
  width: max-content;
  max-width: 160px;
  padding: 4px 8px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.96);
  color: #1a1a2e;
  font-size: 12px;
  line-height: 1.35;
  white-space: normal;
  word-break: break-word;
  pointer-events: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);
  transform: translateX(-50%);
  animation: chatBubbleLife 3s linear forwards;

  &::after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: -5px;
    width: 0;
    height: 0;
    margin-left: -5px;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid rgba(255, 255, 255, 0.96);
  }
}

@keyframes chatBubbleLife {
  0% { opacity: 0; transform: translateX(-50%) translateY(4px); }
  8% { opacity: 1; transform: translateX(-50%) translateY(0); }
  82% { opacity: 1; transform: translateX(-50%) translateY(0); }
  100% { opacity: 0; transform: translateX(-50%) translateY(-4px); }
}

@media (max-width: 768px) {
  .chat-bubble {
    max-width: 120px;
    font-size: 11px;
    padding: 3px 6px;
  }
}
</style>
